import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=742e2f4e&"
import script from "./Discount.vue?vue&type=script&lang=js&"
export * from "./Discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Discount.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742e2f4e')) {
      api.createRecord('742e2f4e', component.options)
    } else {
      api.reload('742e2f4e', component.options)
    }
    module.hot.accept("./Discount.vue?vue&type=template&id=742e2f4e&", function () {
      api.rerender('742e2f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/PaymentMethods/Discount.vue"
export default component.exports